import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { Message } from "../components/Message";
import { Sender } from "../consts";

export const SendClassRequestMessage = () => {
  const { t } = useTranslation("client\\components\\chat\\teacherPullChat");
  const { currentUser } = useSession();

  const learners = currentUser?.children;
  const hasLearners = !!learners?.length;

  return (
    <Message
      text={
        hasLearners
          ? t(
              "Select your learner and share details like topics, skill level, and schedule. We’ll share this info with teachers to find the perfect class—more details mean better recommendations!"
            )
          : t(
              "Share details about your learner—age, topics, and schedule. We’ll share this info with teachers to find the perfect class—more details mean better recommendations!"
            )
      }
      sender={Sender.System}
    />
  );
};
